import React from 'react';
import { motion } from 'framer-motion';
import { Flame } from 'lucide-react';
import { GamerButton } from './ui/GamerButton';
export function HeroSection() {
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gamer-dark pt-20 pb-16 px-4" data-id="element-119">
      {/* Background Effects */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-gamer-red/20 via-gamer-darker to-gamer-darker opacity-60 z-0" data-id="element-120"></div>
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre.png')] opacity-20 z-0 mix-blend-overlay" data-id="element-121"></div>

      <div className="relative z-10 max-w-4xl mx-auto text-center flex flex-col items-center" data-id="element-122">
        {/* Badge */}
        <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="inline-flex items-center gap-2 bg-gamer-red/10 border border-gamer-red/30 rounded-full px-4 py-1.5 mb-8 backdrop-blur-sm" data-id="element-123">
          <Flame className="w-4 h-4 text-gamer-red animate-pulse" data-id="element-124" />
          <span className="text-gamer-red text-xs md:text-sm font-bold tracking-widest uppercase" data-id="element-125">
            Guía Exclusiva Para Jugadores Competitivos
          </span>
        </motion.div>

        {/* Headline */}
        <motion.h1 initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.2
      }} className="text-4xl md:text-6xl lg:text-7xl font-orbitron font-black text-white leading-tight mb-6 drop-shadow-[0_2px_10px_rgba(255,26,26,0.5)]" data-id="element-126">
          Dejá de perder partidas en{' '}
          <span className="text-gamer-red" data-id="element-127">Free Fire</span> y empezá a dominar
          como el 10% que sí sabe lo que hace
        </motion.h1>

        {/* Subtitle */}
        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.7,
        delay: 0.5
      }} className="text-gray-300 text-lg md:text-xl max-w-2xl mx-auto mb-10 font-inter leading-relaxed" data-id="element-128">
          Descubrí el sistema que usan los jugadores que suben de rango más
          rápido, ganan más enfrentamientos y dejan de jugar como promedio.
        </motion.p>

        {/* CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.8
      }} className="w-full md:w-auto" data-id="element-129">
          <GamerButton fullWidth scrollTo="product-section" className="md:w-auto md:px-12 text-xl" data-id="element-130">
            QUIERO DOMINAR FREE FIRE
          </GamerButton>
        </motion.div>

        {/* Social Proof / Urgency Hint */}
        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.5,
        delay: 1.2
      }} className="mt-6 text-sm text-gray-500 font-inter" data-id="element-131">
          <span className="text-gamer-yellow" data-id="element-132">⚠</span> Estrategia probada en la
          última temporada
        </motion.p>
      </div>
    </section>;
}